module.exports = __webpack_public_path__ + "static/media/close-banner-icon.437f90fe.svg";